import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useAuth } from 'react-oidc-context';

export function useDeleteWarehouseMutation(warehouseId: string) {
  const auth = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      fetch(`/api/warehouse/${warehouseId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.user?.id_token}`,
        },
      }),
    mutationKey: ['warehouseDelete', warehouseId],
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['warehouses'] });
    }
  });
}